module.exports = "label{width:calc(8px * 14)}\n"